import type { MonitoringSlices } from '.';
import type { StateCreator } from 'zustand';

import type { DeviceDelay } from '@cobliteam/common-types';

import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';

export interface DeviceSlice {
  currentDevice: DeviceFragment | undefined;
  deviceToReset: DeviceFragment | undefined;
  deviceStatusAndDelay: DeviceDelay | undefined;
  setCurrentDevice: (device: DeviceFragment) => void;
  setDeviceToReset: (device: DeviceFragment | undefined) => void;
  setDeviceStatusAndDelay: (
    deviceStatusAndDelay: DeviceDelay | undefined
  ) => void;
}

type StateCreatorDevice = StateCreator<
  MonitoringSlices,
  [['zustand/devtools', never]],
  [],
  DeviceSlice
>;

const createDeviceSlice: StateCreatorDevice = (set) => ({
  currentDevice: undefined,
  deviceStatusAndDelay: undefined,
  deviceToReset: undefined,
  setCurrentDevice: (device) => set({ currentDevice: device }),
  setDeviceToReset: (device) => set({ deviceToReset: device }),
  setDeviceStatusAndDelay: (deviceStatusAndDelay) =>
    set({ deviceStatusAndDelay }),
});

export default createDeviceSlice;
